var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-base',{staticClass:"view-loading"},[_c('article',{staticClass:"view-loading__logo"},[_c('div',{staticClass:"view-loading__inner"},[_c('img',{staticClass:"view-loading__figure",attrs:{"src":_vm.$getImageSrc('/statics/images/logos/sayl/color.svg'),"alt":"Sayl"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }